const condensedReport = {
  condensedReport: 'Relatório Condensado',
  sites: 'Sites',
  equipmentModels: 'Tipo de Equipamento',
  equipmentServices: 'Tipo de Serviço',
  buttonText: 'Exportar Relatório',
  from: 'De',
  to: 'Até',
};

export default condensedReport;
